export const FIELD_NAME = {
  AUDIENCE_DETAILS: 'audienceDetails',
  AUDIENCE_LIST: 'audiencesListPaginated',
  AUDIENCE_OVERVIEW: 'audienceOverview',
  AUDIENCE_MATCHES_BY_ASSET: 'audienceMatchesByAsset',
  AUDIENCE_MATCHES_OVER_TIME: 'audienceMatchesOverTime',
  AUDIENCE_BREAKDOWN_BY_TRAFFIC_SOURCE: 'audienceBreakdownByTrafficSource',
  CONTACT_DETAILS: 'contactDetails',
  CRM_OBJECT: 'crmObject'
};